import { frontendURL } from 'dashboard/helper/URLHelper';

const HospedagensIndex = () => import('./pages/HospedagensIndex.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/hospedagens'),
      name: 'hospedagens_index',
      component: HospedagensIndex,
      meta: {
        permissions: ['administrator'],
      },
    },
  ],
};
